import lozad from 'lozad'

export default {
  init: () => {
    const lazyLoader = lozad('[data-lazy]:not([data-loaded])')
    lazyLoader.observe()
  }
}
